import * as React from "react";
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
const SvgTt = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="flag-icons-tt"
    viewBox="0 0 640 480"
    aria-labelledby={titleId}
    aria-describedby={descId}
    {...props}
  >
    {desc ? <desc id={descId}>{desc}</desc> : null}
    {title ? <title id={titleId}>{title}</title> : null}
    <path fill="#fff" d="M0 0h640v480H0z" />
    <path
      fill="#e00000"
      fillRule="evenodd"
      d="M463.7 480 0 1v478.8zM176.3 0 640 479V.2z"
    />
    <path
      fill="#000001"
      fillRule="evenodd"
      d="M27.7.2h118.6l468.2 479.3H492.2z"
    />
  </svg>
);
export default SvgTt;
